"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetRawTransactionResultToJSON = exports.GetRawTransactionResultFromJSONTyped = exports.GetRawTransactionResultFromJSON = void 0;
function GetRawTransactionResultFromJSON(json) {
    return GetRawTransactionResultFromJSONTyped(json, false);
}
exports.GetRawTransactionResultFromJSON = GetRawTransactionResultFromJSON;
function GetRawTransactionResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'raw_tx': json['raw_tx'],
    };
}
exports.GetRawTransactionResultFromJSONTyped = GetRawTransactionResultFromJSONTyped;
function GetRawTransactionResultToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'raw_tx': value.raw_tx,
    };
}
exports.GetRawTransactionResultToJSON = GetRawTransactionResultToJSON;
//# sourceMappingURL=GetRawTransactionResult.js.map